import { render, staticRenderFns } from "./CampanaNotificaciones.vue?vue&type=template&id=017487fa&scoped=true&"
import script from "./CampanaNotificaciones.vue?vue&type=script&lang=js&"
export * from "./CampanaNotificaciones.vue?vue&type=script&lang=js&"
import style0 from "./CampanaNotificaciones.vue?vue&type=style&index=0&id=017487fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017487fa",
  null
  
)

export default component.exports